import * as React from "react";
import { Field } from "formik";
import { useMemo } from "react";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
const IndexSetSelect = ({
  indexSets,
  label = "Index Set",
  help = "Messages that match this stream will be written to the configured index set."
}) => {
  const indexSetOptions = useMemo(
    () => indexSets.filter((indexSet) => indexSet.can_be_default).map(({ id, title }) => ({
      value: id,
      label: title
    })),
    [indexSets]
  );
  return /* @__PURE__ */ React.createElement(Field, { name: "index_set_id" }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(Input, { label, help, id: name, error: error && touched ? error : void 0 }, /* @__PURE__ */ React.createElement(
    Select,
    {
      onBlur,
      onChange: (newValue) => onChange({
        target: { value: newValue, name }
      }),
      options: indexSetOptions,
      inputId: name,
      placeholder: "Select an index set",
      value
    }
  )));
};
export default IndexSetSelect;
